/**
 * Entorno: DEV (servidor de desarrollo)
 *
 * Usar con:  npm start          (ng serve --configuration development)
 *            npm run build:dev  (artefacto que entrega DevOps para el servidor dev)
 *
 * La autenticación la gestiona el portal SINAY (SSO externo).
 * DevOps configura el gateway con cookies accessToken / refreshToken.
 * Tokens expiran en 30 minutos en este entorno.
 */
export const environment = {
  production: false,

  /** API del módulo Recursos Humanos en el servidor de desarrollo */
  BaseUrl: 'https://dev.gateway-rh.srv1954566.hstgr.cloud/api',


  /** Portal SSO: destino si el token no existe o expiró */
  logoutUrl: 'https://dev.srv1954566.hstgr.cloud/',

  /** false en servidor dev: no inyectar datos provisionales */
  isLocalDev: false,

  /**
   * El servicio de IDENTIDAD, que contesta `GET /sesion/actual`.
   *
   * ⚠️ VACÍO A PROPÓSITO en este ambiente. Las cookies `sinay_acceso` /
   * `sinay_refresco` sólo llegan si su `Domain` las cubre, y aquí las apps viven
   * en `sinay.com.mx` mientras las APIs se sirven en `sinay.mx`: son sufijos
   * públicos DISTINTOS, ninguna cookie abarca los dos y el corte no puede ser
   * gradual. Rellenarlo antes daría 401 sin nada que lo delate.
   *
   * Sólo `environment.accesos.ts` lo tiene puesto: ese ambiente vive entero bajo
   * `.srv1954566.hstgr.cloud`.
   */
  identidadUrl: 'https://dev.srv1954566.hstgr.cloud/api/v1',

  /** El login central (`flogin`). Vacío donde `identidadUrl` lo está. */
  loginUrl: 'https://dev.srv1954566.hstgr.cloud/',
};
